import request from '../utils/request'

// 获取营收统计数据
export function getRevenueStatistics(params) {
  return request({
    url: '/statistics/homePageStatistics',
    method: 'post',
    data: params
  })
}

// 分校区统计（包含所有图表数据）
export function getBranchRevenue(params) {
  return request({
    url: '/statistics/businessRevenueStatistics',
    method: 'post',
    data: params
  })
}


export function getClassEnrollmentStatistics(params) {
  return request({
    url: '/statistics/classEnrollmentStatistics',
    method: 'post',
    data: params
  })
}
